import React from 'react';

const SvgVerChosen = props => {
	const { highlitedcolor = '#4B1C46', color = '#AAA2AA' } = props;

	return (
		<svg width={36} height={36} {...props}>
			<g fill="none" fillRule="evenodd">
				<path
					stroke={color}
					strokeLinecap="round"
					strokeWidth={2}
					d="M17.639 8.79l12.345 5.462m-15.407-.125l9.546 9.546M9.624 17.235l4.895 12.582"
				/>
				<path
					fill={highlitedcolor}
					d="M2.7 2.7v8.1a8.1 8.1 0 0 0 8.1-8.1H2.7z"
				/>
				<path
					stroke={highlitedcolor}
					strokeLinecap="round"
					strokeWidth={2}
					d="M3.6 18v13.5"
				/>
				<path
					stroke={color}
					strokeLinecap="round"
					strokeWidth={2}
					d="M18 3.6h13.5"
				/>
			</g>
		</svg>
	);
};

export default SvgVerChosen;
